import type { circlesSection } from '../../../../app/_shared/marketing/landingContent';
import { marketingAvatarSlice } from '../../assets/marketing/avatars/marketingAvatarAssets';
import { Avatar } from './Avatar';
import './landingRef.css';

type Preview = (typeof circlesSection.previews)[number];

export function WalkthroughPreviewCard({
  preview,
  isActive,
  revealed,
}: {
  preview: Preview;
  isActive: boolean;
  revealed: boolean;
}) {
  const faces = marketingAvatarSlice(preview.day - 1, 3);
  const emphasisClass =
    preview.emphasis === 'featured'
      ? 'circle-walkthrough-preview--featured'
      : 'circle-walkthrough-preview--compact';

  return (
    <article
      className={`circle-walkthrough-preview ${emphasisClass}${isActive ? ' circle-walkthrough-preview--active' : ''}`}
      data-active={isActive ? 'true' : 'false'}
      aria-label={`${preview.dayBadge}: ${preview.title}`}
      aria-hidden={!revealed}>
      <div className="circle-walkthrough-preview__top">
        <div className="circle-walkthrough-preview__titleRow">
          <h4 className="circle-walkthrough-preview__title ml-heading-sans">{preview.title}</h4>
          <span className="circle-walkthrough-preview__dayBadge">{preview.dayBadge}</span>
        </div>
        <p className="circle-walkthrough-preview__status">{preview.status}</p>
        <div className="circle-walkthrough-preview__faces" aria-hidden>
          {faces.map((src) => (
            <Avatar key={src} src={src} size="xs" />
          ))}
        </div>
      </div>

      <div className="circle-walkthrough-preview__panel">
        <p className="circle-walkthrough-preview__promptLabel">{preview.promptLabel}</p>
        <p className="circle-walkthrough-preview__prompt">{preview.prompt}</p>
        {preview.helper ? (
          <p className="circle-walkthrough-preview__helper">{preview.helper}</p>
        ) : null}
        {'chips' in preview && preview.chips ? (
          <div className="circle-walkthrough-preview__pills" aria-hidden>
            {preview.chips.map((chip) => (
              <span key={chip} className="circle-walkthrough-preview__pill">
                {chip}
              </span>
            ))}
          </div>
        ) : null}
        {'activityPills' in preview && preview.activityPills ? (
          <div className="circle-walkthrough-preview__pills" aria-hidden>
            {preview.activityPills.map((pill) => (
              <span
                key={pill}
                className="circle-walkthrough-preview__pill circle-walkthrough-preview__pill--activity">
                {pill}
              </span>
            ))}
          </div>
        ) : null}
        {'footerPill' in preview && preview.footerPill ? (
          <div className="circle-walkthrough-preview__pills" aria-hidden>
            <span className="circle-walkthrough-preview__pill circle-walkthrough-preview__pill--wrap">
              {preview.footerPill}
            </span>
          </div>
        ) : null}
      </div>
    </article>
  );
}
